import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Bookmark, Trash2, ExternalLink, Clock } from 'lucide-react';

export default function BookmarksView() {
  const navigate = useNavigate();
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    loadBookmarks();
  }, []);

  const loadBookmarks = async () => {
    try {
      const response = await axios.get(`${API}/bookmarks`);
      setBookmarks(response.data);
    } catch (error) {
      console.error('Error loading bookmarks:', error);
    }
  };

  const deleteBookmark = async (id) => {
    try {
      await axios.delete(`${API}/bookmarks/${id}`);
      loadBookmarks();
    } catch (error) {
      console.error('Error deleting bookmark:', error);
    }
  };

  return (
    <div className="h-full overflow-hidden flex flex-col" data-testid="bookmarks-view">
      <div className="glass-panel border-b border-white/10 p-6">
        <h1 className="text-3xl font-bold" style={{ fontFamily: 'Barlow Condensed' }}>SAVED BOOKMARKS</h1>
        <p className="text-xs text-zinc-400 font-mono mt-1">Your saved articles for offline access</p>
      </div>

      <div className="flex-1 overflow-y-auto p-6">
        {bookmarks.length > 0 ? (
          <div className="space-y-3">
            {bookmarks.map((bookmark) => (
              <div key={bookmark.id} className="glass-panel tactical-border p-4" data-testid="bookmark-card">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h3 className="text-sm font-bold text-white mb-2 hover:text-[#00FF9D] transition-colors cursor-pointer">
                      {bookmark.article_title}
                    </h3>
                    <div className="flex items-center gap-4 text-[10px] text-zinc-500 font-mono">
                      <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>{new Date(bookmark.created_at).toLocaleDateString()}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <a
                      href={bookmark.article_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-zinc-500 hover:text-[#00FF9D] transition-colors"
                    >
                      <ExternalLink className="w-4 h-4" />
                    </a>
                    <button
                      data-testid="delete-bookmark-button"
                      onClick={() => deleteBookmark(bookmark.id)}
                      className="text-zinc-500 hover:text-[#FF3B30] transition-colors"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <Bookmark className="w-12 h-12 text-zinc-600 mx-auto mb-4" />
              <p className="text-zinc-400 font-mono text-sm">No bookmarks saved yet</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}